import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import { authManager } from '../utils/auth';


const Header = () => {
  const { user } = useContext(UserContext);
  const name = user.name;
  const firstChar = name ? name[0].toUpperCase() : 'U';


  const handleLogout = () => {
    // Clears local state and asks the backend to clear the httpOnly auth cookies.
    // App.js's auth:logout listener (dispatched inside logout()) handles the
    // navigate('/') - no need to duplicate it here.
    authManager.logout();
  };


  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      <ul className="navbar-nav">
        <li className="nav-item">
          <button
            className="nav-link btn btn-link"
            data-widget="pushmenu"
            type="button"
          >
            <i className="fas fa-bars"></i>
          </button>
        </li>
      </ul>

      <ul className="navbar-nav ml-auto">
        <li className="nav-item dropdown">
          <button
            className="nav-link p-1 btn btn-link"
            data-toggle="dropdown"
            type="button"
          >
            <div className="user-panel d-flex">
              <div className="image user_div">
                <span className="usercharacter">{firstChar}</span>
              </div>
              <div className="info">
                <span className="d-block f_black">
                  {name} <i className="fa-solid fa-angle-down"></i>
                </span>
              </div>
            </div>
          </button>
          <div className="dropdown-menu dropdown-menu-right">
            <Link to="/profile" className="dropdown-item mb-2">
              <i className="fa-solid fa-user mr-2"></i> Profile
            </Link>
            <button className="dropdown-item" onClick={handleLogout}>
              <i className="fa-solid fa-arrow-right-from-bracket mr-2"></i> Logout
            </button>
          </div>
        </li>
      </ul>
    </nav>

  );
};

export default Header;
